import { BoxcastChannel } from "../models/boxcastChannel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ImgContainer, PlayOverlay } from "./styles";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { styled } from "@mui/material/styles";

interface StreamRowProps {
  channel: BoxcastChannel;
  onPlay(arg1: BoxcastChannel): void;
}

const StreamCard = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
}));

const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

const StreamRow: React.FC<StreamRowProps> = (prop) => {
  return (
    <StreamCard onClick={() => prop.onPlay(prop.channel)}>
      <Box sx={{ position: "relative" }}>
        <ImgContainer>
          <img
            src={prop.channel.poster}
            alt={prop.channel.description || prop.channel.name}
          />
          <PlayOverlay>
            <PlayCircleFilledIcon className="play-icon" />
          </PlayOverlay>
        </ImgContainer>
      </Box>

      <CardContent>
        <Typography
          component="h3"
          variant="h6"
          sx={{
            fontWeight: 600,
            color: "white",
            lineHeight: 1.3,
            fontSize: { xs: "1rem", sm: "1.125rem" },
          }}
        >
          {prop.channel.name}
        </Typography>

        {prop.channel.description && (
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              lineHeight: 1.6,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {prop.channel.description}
          </Typography>
        )}
      </CardContent>
    </StreamCard>
  );
};

export default StreamRow;
